import React, { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { noteTakerStore } from 'shared/stores/noteTakerStore'
import { chatWidgetStore } from 'shared/stores/chatWidgetStore'
import SendMessageModal from 'pages/Students/components/SendMessageModal/SendMessageModal'
import { buildKodaActionChatMessage } from 'widgets/NoteTaker/utils/buildKodaActionPrompt'
import { buildKodaContext } from 'widgets/ChatWidget/kodaContext'
import { ReactComponent as ActionListIcon } from 'assets/icons/dock_article.svg'
import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg'
import ActionItemDraftRow from './ActionItemDraftRow'
import ActionItemRow from './ActionItemRow'
import s from '../NoteTakerDrawer.module.scss'

const SessionActionItemsSection = observer(({ studentName }) => {
	const items = noteTakerStore.actionItemsPersisted
	const hasDraft = Boolean(noteTakerStore.actionItemDraft)
	const count = items.length + (hasDraft ? 1 : 0)
	const [remindItem, setRemindItem] = useState(null)

	const student = noteTakerStore.assignedStudent
	const sessionNote = noteTakerStore.sessionNote

	const handleAskKoda = item => {
		// Page context already carries sessionNoteId while the drawer is open; only add
		// subject/session fields that free chat may still need for an unsaved note.
		chatWidgetStore.openWithPrompt({
			text: buildKodaActionChatMessage(item, { studentName }),
			kodaContext: buildKodaContext({
				source: 'session_note',
				subject: { studentId: student?.id, studentName },
				entities: { sessionNoteId: sessionNote?.id || noteTakerStore.activeSessionNoteId },
				session: { title: sessionNote?.title, summary: sessionNote?.summary },
			}),
		})
	}

	const remindStudents =
		student?.id
			? [{ id: student.id, studentId: student.id, name: student.name || studentName }]
			: []

	return (
		<section className={s.section}>
			<div className={s.sectionHead}>
				<div className={s.sectionTitleWrap}>
					<ActionListIcon />
					<h2>Action items</h2>
					<span className={s.countBadge}>{count}</span>
				</div>
			</div>
			<div className={s.actionList}>
				{items.map(item => (
					<ActionItemRow
						key={item.id}
						item={item}
						studentName={studentName}
						studentId={student?.id}
						onTextChange={(itemId, text) =>
							noteTakerStore.updatePersistedActionItemText(itemId, text)
						}
						onToggleDone={itemId => noteTakerStore.toggleActionItemDone(itemId)}
						onDelete={itemId => noteTakerStore.deleteActionItem(itemId)}
						onAskKoda={handleAskKoda}
						onRemind={setRemindItem}
					/>
				))}
				<ActionItemDraftRow studentName={studentName} studentId={student?.id} />
			</div>
			<button
				type="button"
				className={s.inlineAdd}
				onClick={() => noteTakerStore.startActionItemDraft()}
				disabled={hasDraft}
			>
				<PlusIcon />
				Add action item
			</button>

			<SendMessageModal
				isOpen={Boolean(remindItem)}
				onClose={() => setRemindItem(null)}
				selectedStudents={remindStudents}
				initialMessage={remindItem?.text || ''}
			/>
		</section>
	)
})

export default SessionActionItemsSection
